import { PATHS } from '../../config/consts';
import { ICompanyRoles, ISiteRoles } from '../../hooks/rolesHooks';
import { Roles } from '../../modules/commonTypes';
import { replaceURLParams } from '../../routes/helpers/pathParamsReplacer';

export interface IUserData {
  lastVisitedCompanyId?: number | null;
  lastVisitedSiteId?: number | null;
  companies: ICompanyRoles[];
}

export function getRedirectPathForCurrentUser(userData: IUserData) {
  if (userData.lastVisitedSiteId !== undefined && userData.lastVisitedSiteId !== null) {
    const companyId = getAccessibleCompanyIdBySiteId(userData.companies, userData.lastVisitedSiteId);
    if (companyId !== undefined) {
      return replaceURLParams({
        params: { companyId: companyId.toString(), siteId: userData.lastVisitedSiteId.toString() },
        url: PATHS.SITE_DASHBOARD
      });
    }
  }

  if (
    userData.lastVisitedCompanyId !== undefined &&
    userData.lastVisitedCompanyId !== null &&
    canAccessCompanyDashboard(userData.companies, userData.lastVisitedCompanyId)
  ) {
    return replaceURLParams({ params: { companyId: userData.lastVisitedCompanyId.toString() }, url: PATHS.COMPANY_DASHBOARD });
  }

  if (userData.companies.length > 0) {
    if (userData.companies[0].sites!.length > 0 && canAccessFirstSite(userData.companies[0].sites!)) {
      return replaceURLParams({
        params: { companyId: userData.companies[0].id.toString(), siteId: userData.companies[0].sites![0].id.toString() },
        url: PATHS.SITE_DASHBOARD
      });
    }
    if (canAccessFirstCompanyDashboard(userData.companies)) {
      return replaceURLParams({ params: { companyId: userData.companies[0].id.toString() }, url: PATHS.COMPANY_DASHBOARD });
    }
  }

  if (isApartmentAdmin(userData.companies)) {
    return PATHS.USERS_IN_APARTMENTS;
  }

  return PATHS.USER_PROFILE;
}

function getAccessibleCompanyIdBySiteId(companies: ICompanyRoles[], siteId: number): number | undefined {
  const company = companies.find((company) => company.sites?.find((site) => site.id === siteId));
  const userRolesBySite = company?.sites?.find((site) => site.id === siteId);
  if (userRolesBySite?.roles.some((role) => role === Roles.ADMIN)) {
    return company?.id;
  }

  return undefined;
}

function canAccessCompanyDashboard(companies: ICompanyRoles[], companyId: number): boolean {
  const companyRoles = companies.find((company) => company.id === companyId);

  return companyRoles?.roles.includes(Roles.COMPANY_ADMIN) ?? false;
}

function canAccessFirstCompanyDashboard(companies: ICompanyRoles[]): boolean {
  return companies[0].roles.includes(Roles.COMPANY_ADMIN);
}

function canAccessFirstSite(sites: ISiteRoles[]): boolean {
  return !!sites?.[0]?.roles.some((role) => role === Roles.COMPANY_ADMIN || role === Roles.ADMIN);
}

function isApartmentAdmin(companies: ICompanyRoles[]): boolean {
  return !!companies?.find(
    (company) =>
      company?.sites?.find(
        (site) => site?.apartments?.find((apartment) => apartment?.roles?.includes(Roles.APARTMENT_ADMIN))
      )
  );
}
